import type { TFunction } from 'i18next';
export const mapTermsUrl = (agreementName: string, t: TFunction) => {
    switch (agreementName) {
        case 'TraderaPayUnderLicense_v1_5':
            return t('traderapay_termsUnderLicense_v1_5');
        case 'TraderaPayUnderLicense_v1_4':
            return t('traderapay_termsUnderLicense_v1_4');
        case 'TraderaPayNotUnderLicense_v1_4':
            return t('traderapay_termsNotUnderLicense_v1_4');
        case 'TraderaPayNotUnderLicense_v1_3':
        default:
            return t('traderapay_termsNotUnderLicense_v1_3');
    }
};
